export default __webpack_public_path__ + "static/Wiki_Tiles_P-IN-9420WQHD_white-1e6219dc1dd6a2ca0a3f01eca8f7b74e.webp";